import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=ddf88f3c&scoped=true&"
import script from "./EditMember.vue?vue&type=script&lang=js&"
export * from "./EditMember.vue?vue&type=script&lang=js&"
import style0 from "./EditMember.vue?vue&type=style&index=0&id=ddf88f3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf88f3c",
  null
  
)

export default component.exports